/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForGcpProject extends models.ServiceAccountNativeDetailsBaseForGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForGcpProject");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForGcpProject.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForGcpProject>): ServiceAccountNativeDetailsForGcpProject {
        let obj = Object.assign(new ServiceAccountNativeDetailsForGcpProject(), model);
        ServiceAccountNativeDetailsForGcpProject.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForGcpProject>): ServiceAccountNativeDetailsForGcpProject {
        if (!model) return null;
        return ServiceAccountNativeDetailsForGcpProject.newInstance(<ServiceAccountNativeDetailsForGcpProject> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForGcpProject) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForGcpProject.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForGcpProject): boolean {
        if (models.ServiceAccountNativeDetailsBaseForGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForGcpProject.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.default_values) {
            models.SelfServiceDefaultValuesForGcp.fixupPrototype(this.default_values);
        }
    }

    /**
     * Project Id. This is a required field.
     */
    project_id: string;

    /**
     * Unique resource name of the project
     */
    project_sys_generated_name: string;

    /**
     * Project Name
     */
    project_name: string;

    /**
     * Self Service Default Values
     */
    default_values: models.SelfServiceDefaultValuesForGcp;

}
